import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { AppOwnership, UserInterfaceIdiom } from "./Constants.types";
import ExponentConstants from "./ExponentConstants";
export { AppOwnership, UserInterfaceIdiom };

if (!ExponentConstants) {
  console.warn("No native ExponentConstants module found, are you sure the expo-constants's module is linked properly?");
}

var manifest = null;

if (ExponentConstants && ExponentConstants.manifest) {
  manifest = ExponentConstants.manifest;

  if (typeof manifest === 'string') {
    manifest = JSON.parse(manifest);
  }
}

var _ref = ExponentConstants || {},
    name = _ref.name,
    constants = _objectWithoutProperties(_ref, ["name"]);

export default _objectSpread(_objectSpread({}, constants), {}, {
  manifest: manifest,
  deviceId: constants.installationId,
  linkingUrl: constants.linkingUri
});